import { styled } from "goober";
import type { ReactNode } from "react";
import { Text } from "../Text";
import { IconBadge } from "./shared";

const FilledIconBadge = styled(IconBadge)`
  background: var(--alpha4);
`;

const TitleLine = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

const Identity = styled("div")`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

const IdentityCopy = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export function Cell({ value }: { value: string }) {
  return (
    <Text variant="text-small" ellipsis>
      {value}
    </Text>
  );
}

export function IdentityCell({
  title,
  subtitle,
  icon,
  badge,
}: {
  title: string;
  subtitle: string;
  icon: ReactNode;
  badge?: ReactNode;
}) {
  return (
    <Identity>
      <FilledIconBadge>{icon}</FilledIconBadge>
      <IdentityCopy>
        <TitleLine>
          <Text variant="text-regular-md" ellipsis>
            {title}
          </Text>
          {badge}
        </TitleLine>
        <Text variant="text-small" color="var(--text-secondary)" ellipsis>
          {subtitle}
        </Text>
      </IdentityCopy>
    </Identity>
  );
}
